<script setup>
import Popup from './Popup.vue'
import { watch, toRefs } from 'vue'
import { useMixpanel } from '@/composables/mixpanel'
import ButtonComponent from './ButtonComponent.vue'
import { useStore } from 'vuex'
import SvgIcon from '@/components/SvgIcon.vue'
import { computed } from 'vue'

const props = defineProps({
  open: Boolean,
  text: String,
})
const { open, text } = toRefs(props)

const emit = defineEmits(['update:open'])

const mixpanel = useMixpanel()

const $store = useStore()

const exactText = computed(() => $store.state.exactText)
</script>

<template>
  <Popup
    class="sticky z-40"
    popupStyle="bg-[#0A0D22] w-[625px] pt-[50px] pb-5 px-[30px] lg:py-[75px] mx-4 lg:mx-0 lg:px-[122px]"
    :open="open"
    :mobile="false"
    @update:open="emit('update:open', $event)"
  >
    <div class="px-1 py-2 md:px-4 md:py-5 sm:p-6 mt-2">
      <template v-if="text">
        <h2 class="text-xl lg:text-3xl font-bold lg:leading-10">
          Subscription Expired
        </h2>
        <h3 class="mt-1">
          {{ exactText ? text : `Renew your subscription in order to ${text}` }}
        </h3>
      </template>
      <label for="gender" class="block text-sm font-semibold mt-6 text-white">
        And much more:
      </label>
      <ul
        class="mt-3 font-semibold text-white grid gap-y-3 gap-x-2 grid-cols-[20px_1fr] grid-cols-2 items-center"
      >
        <SvgIcon icon-id="check-circle" class="w-[20px] h-[20px]" />
        <span>Unlimited Messaging</span>
        <SvgIcon icon-id="check-circle" class="w-[20px] h-[20px]" />
        <span>Create up to 25 Girls</span>
        <SvgIcon icon-id="check-circle" class="w-[20px] h-[20px]" />
        <span>Generate up to 70 Uncensored Pics</span>
        <SvgIcon icon-id="check-circle" class="w-[20px] h-[20px]" />
        <span>Create Videos From Pictures</span>
      </ul>
      <div
        class="flex justify-between mt-6 lg:mt-10 text-sm font-semibold gap-x-3 text-center"
      >
        <ButtonComponent
          to="/subscribe"
          class="p-2 lg:p-3 w-full"
          @click="$emit('update:open', false)"
          >Upgrade</ButtonComponent
        >
      </div>
    </div>
  </Popup>
</template>
